import React from "react";
import styles from "./CategorySelectorItem.module.css";
import { handleImgError } from "../../Shared/ImageError";

function CategorySelectorItem({ category, index, categoryClicked }) {
  return (
    <div key={index} onClick={() => categoryClicked(category)} className={styles.CarouselItem}>
      <img
        src={
          category.Image
            ? category.Image.src
            : `/Images/Content/mh-registered-white.png`
        }
        alt={category.Image?.alt}
        className={styles.Image}
        onError={handleImgError}
      />

      <div className={styles.Title}>{category.Value}</div>
    </div>
  );
}

export default CategorySelectorItem;
